module.exports = __webpack_public_path__ + "img/deposit.ddc70927.png";